import { Component, Input, Output, EventEmitter,OnInit   } from '@angular/core';


@Component({
  selector: 'app-califica-curso',
  templateUrl: './califica-curso.component.html',
  styleUrls: ['./califica-curso.component.scss'],
})
export class CalificaCursoComponent implements OnInit {

  @Input() max = 5;
  @Input() rating = 0;
  @Output() ratingChange = new EventEmitter<number>();

  get stars() {
    let stars = [];
    for(let i=0; i<this.max; i++) {
      stars.push(i < this.rating);
    }
    return stars;
  }

  onRate(rating: number) {
    this.rating = rating;
    this.ratingChange.emit(this.rating);
  }
  constructor(
   
  ) { }

  ngOnInit() {

  }


}
